import { userProfiles } from "types/user"

export const getRoleName = (id: string) => {
  const foundItem = userProfiles?.find(profile => {
    return profile.id===id
  })  
  return foundItem
}